import {Component, OnInit} from '@angular/core';
import {EmotionService} from '../../../../services/emotion/emotion.service';
import {SpeechService} from '../../../../services/speech/speech.service';
import {Prediction} from '../../../../models/Prediction';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit {
  public chartType = 'line';
  refreshScope = true;
  public chartDatasets: Array<any> = [
    {data: [], label: 'angry'},
    {data: [], label: 'disgust'},
    {data: [], label: 'fear'},
    {data: [], label: 'happy'},
    {data: [], label: 'neutral'},
    {data: [], label: 'sad'},
    {data: [], label: 'surprise'},
    {data: [], label: 'contemptuous'}
  ];

  angryDS: Array<number> = new Array<number>();
  disgustDS: Array<number> = new Array<number>();
  fearDS: Array<number> = new Array<number>();
  happyDS: Array<number> = new Array<number>();
  neutralDS: Array<number> = new Array<number>();
  sadDS: Array<number> = new Array<number>();
  surpriseDS: Array<number> = new Array<number>();
  contemptuousDS: Array<number> = new Array<number>();
  counter = 0;
  public chartLabels: Array<any> = [];
  public chartColors: Array<any> = [
    {
      backgroundColor: 'transparent',
      borderColor: '#FAAF13',
      borderWidth: 3,
    },
    {
      backgroundColor: 'transparent',
      borderColor: '#583342',
      borderWidth: 3,
    },
    {
      backgroundColor: 'transparent',
      borderColor: '#7C8B30',
      borderWidth: 3,
    },
    {
      backgroundColor: 'transparent',
      borderColor: '#A72229',
      borderWidth: 3,
    },
    {
      backgroundColor: 'transparent',
      borderColor: '#292148',
      borderWidth: 3,
    },
    {
      backgroundColor: 'transparent',
      borderColor: '#504F4F',
      borderWidth: 3,
    },
    {
      backgroundColor: 'transparent',
      borderColor: '#0475C0',
      borderWidth: 3,
    },
    {
      backgroundColor: 'transparent',
      borderColor: '#D74407',
      borderWidth: 3,
    }
  ];

  public chartOptions: any;

  constructor(private emotionService: EmotionService, private speechService: SpeechService) {
  }

  initEmotion() {
    this.counter = 0;
    this.emotionService.onPredictionChart = (prediction: Prediction) => {
      this.addData(++this.counter, prediction);
    };
  }

  initSound() {
    this.counter = 0;
    this.speechService.onPredictionChart = (prediction: Prediction) => {
      this.addData(++this.counter, prediction);
    };
  }


  ngOnInit() {
    this.loadChartOptions();
    this.clear();
  }

  refreshChart() {
    this.refreshScope = false;
    setTimeout(() => {
      this.refreshScope = true;
    }, 50);

  }

  loadChartOptions() {
    setTimeout(() => {
      this.chartOptions = {
        responsive: true,
        legend: {
          display: true
        },
        tooltips: {
          callbacks: {
            label(tooltipItem: any) {
              return '';
            }
          }
        },
        elements: {
          line: {
            tension: 0, // disables bezier curves
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              max: 100,
              min: 0,
              beginAtZero: true
            }
          }],
          xAxes: [{
            ticks: {
              callback(value: any, index: any, values: any) {
                return '';
              }
            }
          }]
        },
        animation: false,
        // Container for pan options
        pan: {
          // Boolean to enable panning
          enabled: false,

          // Panning directions. Remove the appropriate direction to disable
          // Eg. 'y' would only allow panning in the y direction
          mode: 'x'
        },
        // Container for zoom options
        zoom: {
          // Boolean to enable zooming
          enabled: true,

          // Zooming directions. Remove the appropriate direction to disable
          // Eg. 'y' would only allow zooming in the y direction
          mode: 'x',
          sensitivity: 3,
          limits: {
            max: 100,
            min: 0
          }
        }
      };
    }, 0);
  }

  addData(label: any, prediction: Prediction) {
    if (prediction != null) {
      if (this.counter > 20) {
        this.angryDS.shift();
        this.disgustDS.shift();
        this.fearDS.shift();
        this.happyDS.shift();
        this.neutralDS.shift();
        this.sadDS.shift();
        this.surpriseDS.shift();
        this.contemptuousDS.shift();
      }
      this.angryDS.push(this.getRoundNumber(prediction.angry ?? 0));
      if (prediction.disgust) {
        this.disgustDS.push(this.getRoundNumber(prediction.disgust));
      } else if (prediction.disgusted) {
        this.disgustDS.push(this.getRoundNumber(prediction.disgusted));
      }
      if (prediction.fear) {
        this.fearDS.push(this.getRoundNumber(prediction.fear));
      } else if (prediction.fearful) {
        this.fearDS.push(this.getRoundNumber(prediction.fearful));
      }
      this.happyDS.push(this.getRoundNumber(prediction.happy ?? 0));
      this.neutralDS.push(this.getRoundNumber(prediction.neutral ?? 0));
      this.sadDS.push(this.getRoundNumber(prediction.sad ?? 0));
      if (prediction.surprise) {
        this.surpriseDS.push(this.getRoundNumber(prediction.surprise));
      } else if (prediction.surprised) {
        this.surpriseDS.push(this.getRoundNumber(prediction.surprised));
      }
      if (prediction.contemptuous) {
        this.contemptuousDS.push(this.getRoundNumber(prediction.contemptuous));
      } else {
        this.contemptuousDS.push(0);
      }

      this.updateChartDataSets();
      if (this.counter > 20) {
        this.chartLabels.shift();
      }
      this.chartLabels.push(label);
    }
  }


  clearEmotionDataSets() {
    this.angryDS.length = 0;
    this.disgustDS.length = 0;
    this.fearDS.length = 0;
    this.happyDS.length = 0;
    this.neutralDS.length = 0;
    this.sadDS.length = 0;
    this.surpriseDS.length = 0;
    this.contemptuousDS.length = 0;
  }

  updateChartDataSets() {
    this.chartDatasets = [
      {data: this.angryDS, label: 'angry'},
      {data: this.disgustDS, label: 'disgust'},
      {data: this.fearDS, label: 'fear'},
      {data: this.happyDS, label: 'happy'},
      {data: this.neutralDS, label: 'neutral'},
      {data: this.sadDS, label: 'sad'},
      {data: this.surpriseDS, label: 'surprise'},
      {data: this.contemptuousDS, label: 'contemptuous'}
    ];
  }

  clear() {
    this.clearEmotionDataSets();
    this.updateChartDataSets();
    this.chartLabels = [];
    this.counter = 0;
    // this.refreshChart();
  }

  getRoundNumber(num: number): number {
    const precision = 2;
    const multiplier = Math.pow(10, precision || 0);
    const result = (Math.round(num * multiplier) / multiplier) * 100;
    // console.log(Math.round(result));
    return Math.round(result);
  }
}
